import { Component, OnInit, Optional, Inject, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnDestroy} from '@angular/core';
import { Column, CdtSettings, DataManager, RequestMetadata } from '../../../../lib/ng-crud-table';
import { DemoService } from '../demo.service';
import { getColumnsHeaders, getColumnsPlayers } from '../columns';
import { SelectItem } from '../../../../lib/common';
import { DtMessages, DtMessagesEn } from '../../../../lib/dt-translate';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { rsltTypeInTitle, rsltTypeInAPICall } from '../functions/title';
import { strictEqual } from 'assert';
import { CommonFilterService } from '../services/common-filter/common-filter.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SwUpdate } from '@angular/service-worker';

//File-Saver for downloading PDF - IMP
declare var require: any
const FileSaver = require('file-saver');

//https://mazdik.github.io/ng-crud-table/#/

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.scss']
})

//https://stackoverflow.com/questions/49159416/url-change-not-firing-in-angular/49159722#49159722
//https://stackblitz.com/edit/angular-re-initialize-component-when-route-params-change?file=app%2Fviews%2Fa%2Fa.component.ts
//https://blogs.ibs.com/2018/07/10/angular-refreshing-a-route-with-parameters/
//https://stackblitz.com/edit/angular-kwfoxw?file=src%2Fapp%2Fapp.component.ts
//https://angular-2-training-book.rangle.io/routing/query_params
//https://medium.com/better-programming/angular-6-url-parameters-860db789db85
export class BasicComponent implements OnInit, OnChanges, OnDestroy {// implements OnInit {
  popupOrNot = false;//displaying as main screen or popup for google maps or graphs icon click

  @Input() rsltType: string;
  rsltTypeTS = '-1';
  deleteColumnFilter = '';

  TSSelected: number;
  DataTSSelected: number;

  AutoRefreshInfo: any;

  isLoading: boolean = false;

  //https://stackoverflow.com/questions/38571812/how-to-detect-when-an-input-value-changes-in-angular
  //https://medium.com/@bharat.tiwari/intercept-input-property-change-in-angular-690567eb63ec
  //https://stackblitz.com/edit/setter-and-getter-input?file=src%2Fapp%2Fchild%2Fchild.component.ts
  @Input() selectedSubResults: any;
  //_selectedSubResults: any;
  //@Input()
  //set selectedSubResults(val: any) { this._selectedSubResults = val; /* more code */ }
  //get selectedSubResults(): any { return this._selectedSubResults; }

  @Input() boolMainHeader: boolean = false;
  columns: Column[];
  selectedColumns: SelectItem[] = [];
  dataManager: DataManager;
  @Input() requestID: string;

  title: string;
  @Output() childTitleEvent = new EventEmitter<string>();

  settings: CdtSettings = new CdtSettings({
    crud: false,//create button toggle used to create dynamic row from columns set - IMP
    bodyHeight: 380,
    exportAction: true,
    exportKMLAction: true,
    globalFilter: false,
    columnToggleAction: false,
    clearAllFiltersAction: true,
    unshiftExpandIcon: false,//Toggle frst dynamic column haing icon to show details view, update, etc as menu items - IMP
  });

  messages: DtMessages = new DtMessagesEn({
    titleDetailView: 'Player details',
    titleCreate: 'Create a new player'
  });

  private subscriptions: Subscription[] = [];
  //public subscribers: any = {};
  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private service: DemoService, private commonFilterService: CommonFilterService,
    public dialogBox: MatDialogRef<BasicComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private responsive: BreakpointObserver, private swUpdate: SwUpdate) {
    //console.log(swUpdate.isEnabled)
    if (swUpdate.isEnabled) {
      swUpdate.available.subscribe(() => {
        console.log('New version available. Reloading...');
        //swUpdate.activateUpdate().then(() => document.location.reload());
      });
    }

    this.popupOrNot = false;
    this.commonFilterService.setNonFiltersScreen(false);
    if (data) {
      if (data.popupOrNot) {
        this.popupOrNot = true;
        this.requestID = data.requestID;
        this.rsltType = data.rsltType;

        this.settings = new CdtSettings({
          crud: false,//create button toggle used to create dynamic row from columns set - IMP
          //bodyHeight: 980,
          globalFilter: false,
          //clickRows: true,
          columnToggleAction: false,
          clearAllFiltersAction: false,
          unshiftExpandIcon: false,//Toggle frst dynamic column haing icon to show details view, update, etc as menu items - IMP
          paginator: false,
        });
        this.DataTSSelected = data.TSSelected;

        //this.setRsltType();-NOT NEEDED 
        //this.parentRef(data.TSSelected);
      }
    }

    //this._Activatedroute.params.subscribe(val => {      
    //  //this.rsltType = this._Activatedroute.snapshot.params.urlRslt;
    //  this.rsltType = val.urlRslt;
    //  if (this.rsltType == null)
    //    this.rsltType = "pesq";
    //  this.setRsltType();
    //});

    //this.columns = getColumnsCallEvents();//getColumnsPlayers();
    ////this.columns.forEach((x, i) => (i > 0) ? x.editable = true : x.editable = false);//IMP-edit each cell

    ////this.columns[4].filterValues = this.filterValuesFunc;
    //this.dataManager = new DataManager(this.columns, this.settings, this.service, this.messages);
    //this.dataManager.pager.perPage = 20;

    this.commonFilterService.TSType.subscribe(res => this.TSSelected = res);//When page changed keep curr selected TSType, Refresh and Auto refresh are emitting this value separately - IMP

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.setRsltType();
      }
    );
    this.subscriptions.push(_broadSubRefresh);
    //subscribed to delete subject emitted by synopsis component, thus detect delete operation automatically and refresh screen
    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(res => {
      if (res !== '') {//IMP IMP
        this.deleteColumnFilter = res;
        this.setRsltType();//IMP
      }
    });
    this.subscriptions.push(_broadSubDeleteFilter);
    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);

    //https://blog.angular-university.io/angular-responsive-design/
    //https://indepth.dev/posts/1383/responsive-angular
    //https://netbasal.com/improved-responsiveness-for-improved-performance-in-angular-apps-57bd49a71d17
    //https://www.digitalocean.com/community/tutorials/detect-responsive-screen-sizes-in-angular
    this.responsive.observe([Breakpoints.Web, Breakpoints.WebLandscape, Breakpoints.WebPortrait,
    Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
    Breakpoints.Handset, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
    Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge
    ])
      .subscribe(result => {

        const breakpoints = result.breakpoints;
        //console.log(breakpoints)

        //console.log('Web ' + breakpoints[Breakpoints.Web]);
        //console.log('WebLandscape ' + breakpoints[Breakpoints.WebLandscape]);
        //console.log('WebPortrait ' + breakpoints[Breakpoints.WebPortrait]);

        //console.log('Tablet ' + breakpoints[Breakpoints.Tablet]);
        //console.log('TabletPortrait ' + breakpoints[Breakpoints.TabletPortrait]);
        //console.log('TabletLandscape ' + breakpoints[Breakpoints.TabletLandscape]);

        //console.log('Handset ' + breakpoints[Breakpoints.Handset]);
        //console.log('HandsetLandscape ' + breakpoints[Breakpoints.HandsetLandscape]);
        //console.log('HandsetPortrait ' + breakpoints[Breakpoints.HandsetPortrait]);

        //console.log('XSmall ' + breakpoints[Breakpoints.XSmall]);
        //console.log('Small ' + breakpoints[Breakpoints.Small]);
        //console.log('Medium ' + breakpoints[Breakpoints.Medium]);
        //console.log('Large ' + breakpoints[Breakpoints.Large]);
        //console.log('XLarge ' + breakpoints[Breakpoints.XLarge]);

        if (breakpoints[Breakpoints.XLarge] || breakpoints[Breakpoints.Large]) {
          this.settings.bodyHeight = 380 * 2;
          //this.settings.rowHeight = this.settings.rowHeight * 2;
        }
        else if (breakpoints[Breakpoints.Medium]) {
          this.settings.bodyHeight = 380 * 1.5;
        }
        else if (breakpoints[Breakpoints.Small]) {
          this.settings.bodyHeight = 380;
        }
        //if (breakpoints[Breakpoints.TabletPortrait]) {
          //console.log("screens matches TabletPortrait");
        //}
        //else if (breakpoints[Breakpoints.HandsetLandscape]) {
          //console.log("screens matches HandsetLandscape");
        //}

      });
    //this.service.testWebAPISample();
  }

  ngOnInit() {
    this.isLoading = false;
    //console.log(this.selectedSubResults);
    if (this.popupOrNot == true)
      this.parentRef(this.DataTSSelected);
  }
  ngOnDestroy() {
    //https://dev.to/this-is-angular/dry-way-to-manage-subscriptions-in-angular-components-256j
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  ngOnChanges(changes: SimpleChanges) {
    
    //https://dev.to/nickraphael/ngonchanges-best-practice-always-use-simplechanges-always-1feg
    //for (const propName in changes) {
    //  if (changes.hasOwnProperty(propName)) {
    //    switch (propName) {
    //      case 'selectedSubResults': {
    //        if (changes.currentValue != undefined)
    //          this.selectedSubResults = changes.currentValue;

    //        break;
    //      }
    //    }
    //  }
    //}

    //if (this.popupOrNot == true) {
      this.setRsltType();
    //}
  }

  filterValuesFunc(columnName: string): Promise<SelectItem[]> {
    return new Promise((resolve) => {
      setTimeout(() => resolve(
        [
          { id: 'MALE', name: 'MALE' },
          { id: 'FEMALE', name: 'FEMALE' },
        ]
      ), 1000);
    });
  }

  async setRsltType() {
    //console.log(new Date())
    //https://stackoverflow.com/questions/208105/how-do-i-remove-a-property-from-a-javascript-object - Not needed
    //https://love2dev.com/blog/javascript-remove-from-array/ - Not Needed
    //https://www.freecodecamp.org/news/manipulating-arrays-in-javascript/ - Not Needed
    let TSTypesHidden = "";

    switch (this.rsltType) {
      case "pesq":
        this.rsltTypeTS = '-1';
        if (this.TSSelected == 2) {//for vqt TS selection in common filter
          TSTypesHidden = "VQuad_Timestamp";
          this.selectedColumns.every(cols => {
            if (cols.id == "VQuad_Timestamp") {
              cols.id = "VQT_TimeStamp";
              cols.name = "VQT Timestamp";
              return false;
            }
            return true;
          })
        }
        else {//for either call or vquad TS selection in common filter
          TSTypesHidden = "VQT_TimeStamp";
          this.selectedColumns.every(cols => {
            if (cols.id == "VQT_TimeStamp") {
              cols.id = "VQuad_Timestamp";
              cols.name = "VQuad Timestamp";
              return false;
            }
            return true;
          })
        }

        //{ id: 'VQT_TimeStamp', name: 'VQT Timestamp' }
        //{ id: 'VQuad_Timestamp', name: 'VQuad Timestamp' }
        //{ id: 'Call_Timestamp', name: 'Call Timestamp' }

        this.settings.columnToggleAction = true;
        break;
      case "polqa":
        this.rsltTypeTS = '-1';
        if (this.TSSelected == 2)//for vqt TS selection in common filter
          TSTypesHidden = "VQuad_Timestamp";
        else//for either call or vquad TS selection in common filter
          TSTypesHidden = "VQT_Timestamp";
        break;
      default:
        this.rsltTypeTS = '2';
        break;
    }
    //console.log(this.selectedSubResults);
    let DAQOrNot = false;
    if (this.rsltType == 'pesq') {
      await this.service.getVqtDAQSetting('VqtData').then(res => {
        DAQOrNot = res;
      });
    }
    this.columns = getColumnsHeaders(this.rsltType, this.selectedSubResults, DAQOrNot);
    if (this.popupOrNot) {
      this.columns.forEach(x => { x.filter = false; });//Disable all cols filters - IMP
    }

    //For Call Timestamp grouping, remove column from main table and show it in each header with count - IMP
    //For other TS Selection can also be used to hide the other TS column
    if (TSTypesHidden !== "")
      this.columns.find(x => x.name === TSTypesHidden).tableHidden = true;

    if (this.TSSelected == 0)//for call TS selection in common filter
    {
      if (this.columns.find(x => x.name === 'Call_Timestamp'))
        this.columns.find(x => x.name === 'Call_Timestamp').tableHidden = true;
      //For Call Timestamp grouping Enabling dynamically - VERY IMP
      //https://github.com/mazdik/ng-mazdik/blob/master/src/app/demo/row-group-demo.component.ts
      this.settings.groupRowsBy = ['Call_Timestamp'];
      this.settings.groupRowsByTitles = ['Call Timestamp'];
      this.settings.rowHeightProp = '$$height';
    }
    else {//reset to vquad/vqt timestamp filter
      if (this.columns.find(x => x.name === 'Call_Timestamp'))
        this.columns.find(x => x.name === 'Call_Timestamp').tableHidden = false;
      //For Call Timestamp grouping Enabling dynamically - VERY IMP
      //https://github.com/mazdik/ng-mazdik/blob/master/src/app/demo/row-group-demo.component.ts
      this.settings.groupRowsBy = [];
      this.settings.groupRowsByTitles = [];
      this.settings.rowHeightProp = '';

    }
    //console.log(this.columns)

    this.title = rsltTypeInTitle(this.rsltType);
    //https://dzone.com/articles/understanding-output-and-eventemitter-in-angular
    this.childTitleEvent.emit(this.title);
    //this.columns.forEach((x, i) => (i > 0) ? x.editable = true : x.editable = false);//IMP-edit each cell

    //this.columns[4].filterValues = this.filterValuesFunc;

    let dbTz = -500;
    //this.commonFilterService.DB_TZ.subscribe(res => {
    //  dbTz = res;
    //});
    //if (dbTz == -500) {//query var col table
    //  await this.service.getDBTimezoneDiff('VquadData').then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    dbTz = res;
    //  });
    //}
    //console.log(dbTz)
    //debugger;
    let MainFilterTZ = 0;
    this.commonFilterService.mfTZ.subscribe(res => MainFilterTZ = res); /// set mainfilter selected ID - elumalai
    //console.log(MainFilterID)
    let dbAndBrHrs = -500;
    //if (MainFilterID != 0) {
      this.commonFilterService.DB_BRDiff.subscribe(res => {
        dbAndBrHrs = res;
      });
      if (dbAndBrHrs == -500) {//query var col table
        await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
          this.commonFilterService.setDBAndBrowserHrsDiff(res);
          dbAndBrHrs = res;
        });
      }
      //console.log(dbAndBrHrs)
    //}

    this.commonFilterService.columnToggleListen.subscribe(res => this.selectedColumns = res);
    //console.log(this.selectedColumns)

    if (this.ResultOrFileType > 0) {
      let groupRowsBybool = false;
      if (this.settings.groupRowsBy) {
        if (this.settings.groupRowsBy.length > 0)
          groupRowsBybool = true;
      }
      const requestMeta: RequestMetadata = {
        pageMeta: { currentPage: this.dataManager.pager.current, perPage: this.dataManager.pager.perPage, perPageOrCurrPageChanged: this.dataManager.pager.perPageOrCurrPageChanged },
        filters: this.dataManager.dataFilter.filters,
        sortMeta: this.dataManager.sorter.sortMeta,
        globalFilterValue: this.dataManager.dataFilter.globalFilterValue,
        rsltType: this.dataManager.rsltType,
        rsltTypeActual: this.dataManager.rsltTypeActual,
        ResultOrFileType: this.ResultOrFileType,
        respColumnsList: this.dataManager.respColumnsList,
        groupRowsBy: groupRowsBybool,
      };
      this.isLoading = true;
      await this.service.getItemsExported(requestMeta).then(res => {
        this.isLoading = false;
      });
    }
    else {
      this.dataManager = new DataManager(this.columns, this.settings, this.service, dbTz, dbAndBrHrs, MainFilterTZ, this.selectedColumns, this.messages, rsltTypeInAPICall(this.rsltType), this.rsltType,
        this.ResultOrFileType, this.requestID);

      if (this.deleteColumnFilter !== '') {
        this.commonFilterService.setDeleteFilterData('');//reset if delete
        this.deleteColumnFilter = '';
      }

      this.commonFilterService.PaginationFilter.subscribe(res => this.dataManager.pager.perPage = res.RecordsPerPage);
      //console.log(this.dataManager.pager.perPage)

      this.commonFilterService.PaginationListners.subscribe(res => { this.dataManager.pager.perPageOrCurrPageChanged = true; });
      //console.log(this.dataManager)
    }
  }


  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
    this.setRsltType();
  }
  parentEventID() {
    this.setRsltType();
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  ResultOrFileType: number = 0;//default result type
  
  onDownloaded(type): void {
    
    //alert("download");
   //debugger;
///1=pdf,2=excel,4=txt
    //debugger
    this.ResultOrFileType = type;//4

    this.setRsltType().finally(() =>
      //console.log('fetchData completed');      
      this.ResultOrFileType = 0//reset-susheel
    );
    //this.setRsltType();
    //this.ResultOrFileType = 0;//reset-susheel

    //let fileName = 'VquadData_202107011629.xlsx';
    //const myFileName = fileName; //'1.pdf';
    //const fileUrl = '/assets/DownloadedReports/' + fileName;
    //const myFileName = 'VquadData_202107011629.xlsx'; //'my-custom-file.pdf';
    //const fileUrl = '/assets/DownloadedReports/VquadData_202107011629.xlsx'; //'/assets/DownloadedReports/WebviewerDummy.pdf';
    ////const fileUrl = 'C:\inetpub\wwwroot\WebviewerScheduler\CustomReports\1.pdf';

    ////https://stackoverflow.com/questions/56100555/angular-7-download-pdf-file-under-app-folder
    ////window.open(fileUrl, '_blank');

    ////https://www.freakyjolly.com/angular-7-8-9-download-pdf-files-in-browser-instead-of-opening-in-new-tab-quick-solution/
    //FileSaver.saveAs(fileUrl, myFileName);
  }

  onFilterCEErrorEvents(getErrorEvent): void {
    //alert('hi');
    
    this.setRsltType();
  }
  onFilterConnDrops(getConnDrop): void {
    //alert('hi');

    this.setRsltType();
  }

}
